import React, { useContext, useState, useEffect } from "react";
import TimeTableContext from "../../../context/timeTableContext";
import { getDailyChanges } from "../../../helpers/ChangesHelpers";
import ChangeBox from "./../ChangeBox";

import Slider from '../../Slider'


const DailyChanges = () => {
  const [value, setValue] = useState(true); // boolean state

  useEffect(() => {
    let id = setInterval(() => {
      setValue(!value);
    }, 900000000);
    return () => clearInterval(id);
  });

  let cssClasses
  const context = useContext(TimeTableContext);
  let changes = getDailyChanges(context);

  return (
    
      <Slider context={context} totalSlide={changes.length}>
        {changes.map((changeOut, index) => {
          cssClasses = index === 1 ? "slide slide_visible" : "slide"
          return (
            <div className={cssClasses}>
              {changeOut.map((change, index) => {
                return <ChangeBox change={change} inTable={false} />;
              })}
            </div>
          );
        })}
      </Slider>
  );
};

export default DailyChanges;
